import React from "react";
import { useNavigate } from "react-router-dom";
import "./CategoryCard.css";
import { getOptimizedUrl } from "../../../constants/globalFunction";

const CategoryCard = ({ category }) => {
  const navigate = useNavigate();

  const handlePress = () => {
    navigate(`/category?category_id=${category?._id}`, {
      state: { category: category },
    });
  };

  return (
    <div
      className="shop-category-card"
      onClick={handlePress}
      role="button"
      tabIndex={0}
    >
      <div className="shop-category-card__image-container">
        {category?.image ? (
          <img
            src={getOptimizedUrl(category?.image)}
            alt={category?.name}
            className="shop-category-card__image"
            loading="lazy"
          />
        ) : (
          <div className="shop-category-card__placeholder">
            <span>No Image</span>
          </div>
        )}
      </div>

      <div className="shop-category-card__content">
        <h3 className="shop-category-card__title">{category?.name}</h3>
        <p className="shop-category-card__count">
          {category?.active_product_count || 0} Products
        </p>
      </div>
    </div>
  );
};

export default CategoryCard;
